import { render } from "./App.vue?vue&type=template&id=2a54fb68"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2a54fb68&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_5d906aecc3bb16048fc15d5a3f05df56/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__